import type { Locale } from "./types";

export const SUPPORTED_LOCALES: readonly Locale[] = ["bs", "en"];

export function localeHreflang(locale: Locale): "bs-BA" | "en" {
  return locale === "bs" ? "bs-BA" : "en";
}

export function contentLanguage(locale: Locale): "bs-BA" | "en" {
  return localeHreflang(locale);
}

export function alternateLocale(locale: Locale): Locale {
  return locale === "bs" ? "en" : "bs";
}

export function localeUrl(origin: string, pathname: string, locale: Locale): string {
  const url = new URL(pathname, origin);
  if (locale === "en") url.searchParams.set("lang", "en");
  return url.toString();
}

export function defaultLocaleUrl(origin: string, pathname: string): string {
  return localeUrl(origin, pathname, "bs");
}

export function localizedUrls(origin: string, pathname: string): Record<Locale, string> {
  return {
    bs: localeUrl(origin, pathname, "bs"),
    en: localeUrl(origin, pathname, "en"),
  };
}
